import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';

export const adminTheme = createTheme({
    palette: {
        primary: { main: '#1A1A1A' },
        secondary: { main: '#C4A35A' },
        background: { default: '#f5f5f5', paper: '#fff' },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: { fontWeight: 700, letterSpacing: '-0.03em' },
        h5: { fontWeight: 600 },
    },
    shape: { borderRadius: 4 },
    components: {
        MuiButton: {
            styleOverrides: {
                root: { textTransform: 'none', fontWeight: 500 },
                containedPrimary: {
                    '&:hover': { opacity: 0.85 },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { border: '1px solid #e5e5e5' },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '& .MuiTableCell-root': { fontWeight: 600, color: '#1A1A1A' },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 500 },
            },
        },
    },
});
